/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListEmbeddingModelsRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListEmbeddingModelsRequest$inboundSchema: z.ZodType<
  ListEmbeddingModelsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListEmbeddingModelsRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListEmbeddingModelsRequest$outboundSchema: z.ZodType<
  ListEmbeddingModelsRequest$Outbound,
  z.ZodTypeDef,
  ListEmbeddingModelsRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listEmbeddingModelsRequestToJSON(
  listEmbeddingModelsRequest: ListEmbeddingModelsRequest,
): string {
  return JSON.stringify(
    ListEmbeddingModelsRequest$outboundSchema.parse(listEmbeddingModelsRequest),
  );
}
export function listEmbeddingModelsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEmbeddingModelsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEmbeddingModelsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEmbeddingModelsRequest' from JSON`,
  );
}
